(function () {
  window.switchLang = function (locale, country) {
    var localeInput = document.getElementById('LocaleInput');
    var countryInput = document.getElementById('CountryInput');
    var form = document.getElementById('LangSwitchForm');
    if (!localeInput || !countryInput || !form) return;
    localeInput.value = locale;
    countryInput.value = country;
    form.submit();
  };

  function initLangToggle() {
    var langIcon = document.querySelector('.lang_icon');
    var langBox = document.querySelector('.pc_lang_box');
    var hamburgerButton = document.querySelector('button[aria-controls="sidebar-menu"]');

    if (!langIcon || langIcon.dataset.srlBound === 'true') return;
    langIcon.dataset.srlBound = 'true';

    langIcon.addEventListener('click', function () {
      if (window.innerWidth <= 1280) {
        if (hamburgerButton) hamburgerButton.click();
      } else if (langBox) {
        langBox.classList.toggle('show');
      }
    });
  }

  function initHeaderLayout() {
    var PC_MIN_WIDTH = 1281;
    var JOIN_INLINE_SLACK = 16;
    var observerRoot = document.querySelector('height-observer.header-observer');
    var sectionId = observerRoot && observerRoot.getAttribute('data-header-section-id');
    var resizeRaf = null;
    var isUpdatingJoinMode = false;

    function updateHeaderHeight() {
      var section = sectionId ? document.getElementById(sectionId) : null;
      if (section) {
        document.documentElement.style.setProperty('--header-height', Math.round(section.clientHeight) + 'px');
      }
    }

    function getJoinMode(root) {
      if (root.classList.contains('header--join-inline')) return 'inline';
      if (root.classList.contains('header--join-bar')) return 'bar';
      return 'none';
    }

    function clearJoinMode(root) {
      root.classList.remove('header--join-inline', 'header--join-bar');
    }

    function setJoinMode(root, mode) {
      if (getJoinMode(root) === mode) return;

      if (mode === 'inline') {
        root.classList.add('header--join-inline');
        root.classList.remove('header--join-bar');
      } else if (mode === 'bar') {
        root.classList.remove('header--join-inline');
        root.classList.add('header--join-bar');
      } else {
        clearJoinMode(root);
      }
    }

    function isPrimaryNavWrapped(primaryNav) {
      if (!primaryNav) return false;

      var items = primaryNav.querySelectorAll('.header__primary-nav-item');
      if (items.length > 1) {
        var firstTop = items[0].offsetTop;
        var hasRowWrap = Array.prototype.some.call(items, function (item) {
          return item.offsetTop > firstTop + 1;
        });
        if (hasRowWrap) return true;
      }

      return primaryNav.scrollWidth > primaryNav.clientWidth + 1;
    }

    function getNavOverflowPx(header, primaryNav) {
      if (!header || !primaryNav || window.innerWidth < PC_MIN_WIDTH) return 0;

      var wrapOverflow = Math.max(0, primaryNav.scrollWidth - primaryNav.clientWidth);
      var items = primaryNav.querySelectorAll('.header__primary-nav-item');
      var lastItem = items[items.length - 1];
      var search = header.querySelector('.index_search_contents');
      var overlap = 0;

      if (lastItem && search) {
        overlap = Math.max(0, lastItem.getBoundingClientRect().right - search.getBoundingClientRect().left);
      }

      return Math.max(wrapOverflow, overlap);
    }

    function updateHeaderSpacing(header, primaryNav) {
      if (!header) return;

      if (window.innerWidth < PC_MIN_WIDTH) {
        header.style.removeProperty('--header-logo-column');
        return;
      }

      var LOGO_COLUMN_MAX = 250;
      var GAP_BUFFER = 8;
      var logo = header.querySelector('.header__logo');
      var logoWidth = logo ? Math.ceil(logo.getBoundingClientRect().width) : 160;
      var logoColumnMin = logoWidth;

      header.style.setProperty('--header-logo-column', LOGO_COLUMN_MAX + 'px');
      void header.offsetWidth;

      var deficit = getNavOverflowPx(header, primaryNav);
      var logoColumn = deficit <= 0
        ? LOGO_COLUMN_MAX
        : Math.max(logoColumnMin, LOGO_COLUMN_MAX - deficit - GAP_BUFFER);

      header.style.setProperty('--header-logo-column', logoColumn + 'px');
    }

    function measureInlineJoinLayout(header, primaryNav, joinBar, joinInline) {
      joinInline.style.setProperty('display', 'inline', 'important');
      if (joinBar) {
        joinBar.style.setProperty('display', 'none', 'important');
      }
      void header?.offsetWidth;

      var overflowPx = getNavOverflowPx(header, primaryNav);
      var wrapped = isPrimaryNavWrapped(primaryNav) || overflowPx > 0;
      var slack = overflowPx > 0
        ? -overflowPx
        : primaryNav
          ? primaryNav.clientWidth - primaryNav.scrollWidth
          : 0;

      joinInline.style.removeProperty('display');
      if (joinBar) {
        joinBar.style.removeProperty('display');
      }

      return { wrapped: wrapped, slack: slack };
    }

    function resolveJoinMode(root, header, joinBar, primaryNav, joinInline) {
      if (window.innerWidth < PC_MIN_WIDTH) {
        return joinBar ? 'bar' : 'none';
      }

      var currentMode = getJoinMode(root);
      var layout = measureInlineJoinLayout(header, primaryNav, joinBar, joinInline);

      if (currentMode === 'inline') {
        if (layout.wrapped && layout.slack < -JOIN_INLINE_SLACK) {
          return joinBar ? 'bar' : 'none';
        }
        return 'inline';
      }

      if (layout.wrapped) {
        return joinBar ? 'bar' : 'none';
      }

      return 'inline';
    }

    function updateJoinMode() {
      if (isUpdatingJoinMode) return;

      var root = document.querySelector('height-observer.header-observer');
      var header = root && root.querySelector('x-header.header');
      var primaryNav = header && header.querySelector('.header__primary-nav');
      var joinBar = root && root.querySelector('[data-join-bar]');
      var joinInline = header && header.querySelector('[data-join-inline]');

      if (!root) {
        updateHeaderHeight();
        return;
      }

      isUpdatingJoinMode = true;

      try {
        root.classList.remove('header--join-pending');

        if (!joinInline) {
          clearJoinMode(root);
        } else {
          if (window.innerWidth >= PC_MIN_WIDTH && header) {
            header.style.setProperty('--header-logo-column', '250px');
            void header.offsetWidth;
          }

          setJoinMode(root, resolveJoinMode(root, header, joinBar, primaryNav, joinInline));
        }

        updateHeaderSpacing(header, primaryNav);
        updateHeaderHeight();
      } finally {
        isUpdatingJoinMode = false;
      }
    }

    function scheduleJoinModeUpdate() {
      if (resizeRaf) {
        cancelAnimationFrame(resizeRaf);
      }

      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        updateJoinMode();
      });
    }

    updateJoinMode();

    var root = document.querySelector('height-observer.header-observer');
    var header = root && root.querySelector('x-header.header');
    var primaryNav = header && header.querySelector('.header__primary-nav');

    if (header && header.dataset.srlLayoutBound !== 'true') {
      header.dataset.srlLayoutBound = 'true';
      var resizeObserver = new ResizeObserver(function () {
        scheduleJoinModeUpdate();
      });
      resizeObserver.observe(header);
      if (primaryNav) resizeObserver.observe(primaryNav);
    }

    if (!window.__srlHeaderResizeBound) {
      window.__srlHeaderResizeBound = true;
      window.addEventListener('resize', scheduleJoinModeUpdate);
      window.addEventListener('load', scheduleJoinModeUpdate);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleJoinModeUpdate);
      }
    }
  }

  function initMegaMenuPromo() {
    if (window.__srlMegaMenuPromoBound) return;
    window.__srlMegaMenuPromoBound = true;

    var megaMenuImages = {};
    var imagesEl = document.getElementById('MegaMenuCollectionImages');
    if (imagesEl) {
      try {
        megaMenuImages = JSON.parse(imagesEl.textContent) || {};
      } catch (error) {
        megaMenuImages = {};
      }
    }

    var promoImgs = [];
    document.querySelectorAll('.mega-menu__promo .overflow-hidden').forEach(function (wrap) {
      Array.prototype.forEach.call(wrap.children, function (child) {
        if (child.tagName === 'IMG') promoImgs.push(child);
      });
    });

    function applyMegaMenuImage(key) {
      var data = megaMenuImages[key];
      if (!data || !data.src) return;
      promoImgs.forEach(function (img) {
        img.setAttribute('src', data.src);
        img.setAttribute('srcset', data.srcset);
        img.setAttribute('sizes', '315px');
      });
    }

    applyMegaMenuImage('ALL');

    document.querySelectorAll('.link-faded').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        applyMegaMenuImage((link.textContent || '').trim());
      });
    });
  }

  function slideToggle(el, duration, title) {
    if (!el) return;

    var fromHeight = el.getBoundingClientRect().height;
    if (el._srlAnimation) {
      el._srlAnimation.cancel();
      el._srlAnimation = null;
    }

    var willOpen = !el._srlOpen;
    el._srlOpen = willOpen;
    if (title) title.classList.toggle('active', willOpen);

    el.style.display = 'flex';
    el.style.overflow = 'hidden';
    el.style.height = fromHeight + 'px';

    var toHeight = willOpen ? el.scrollHeight : 0;
    var animation = el.animate(
      [{ height: fromHeight + 'px' }, { height: toHeight + 'px' }],
      { duration: duration, easing: 'ease' }
    );
    el._srlAnimation = animation;

    animation.onfinish = function () {
      if (el._srlAnimation !== animation) return;
      el._srlAnimation = null;
      if (willOpen) {
        el.style.height = '';
        el.style.overflow = '';
      } else {
        el.style.display = 'none';
        el.style.height = '';
        el.style.overflow = '';
      }
    };
  }

  function initSidebarAccordion() {
    if (window.__srlSidebarAccordionBound) return;
    window.__srlSidebarAccordionBound = true;

    document.querySelectorAll('.link_level2').forEach(function (el) {
      el.style.display = 'none';
      el._srlOpen = false;
    });
    document.querySelectorAll('.level1_title').forEach(function (title) {
      title.addEventListener('click', function () {
        var next = title.nextElementSibling;
        if (next && next.classList.contains('link_level2')) {
          slideToggle(next, 500, title);
        }
      });
    });
  }

  function initFavoriteCount() {
    var favCountEl = document.getElementById('prime-review-favorites-count');
    if (!favCountEl || favCountEl.dataset.srlBound === 'true') return;
    favCountEl.dataset.srlBound = 'true';
    var favCount = Number(favCountEl.textContent) || 0;
    if (favCount <= 0) {
      favCountEl.style.display = 'none';
    } else {
      favCountEl.style.background = '';
      favCountEl.style.display = 'flex';
    }
  }

  function init() {
    initLangToggle();
    initHeaderLayout();
    initMegaMenuPromo();
    initSidebarAccordion();
    initFavoriteCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    window.__srlMegaMenuPromoBound = false;
    window.__srlSidebarAccordionBound = false;
    init();
  });
})();
